import { render } from "./CreateAsli.vue?vue&type=template&id=784253d2"
import script from "./CreateAsli.vue?vue&type=script&lang=js"
export * from "./CreateAsli.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__